/**
 * Slide animation using jQuery
 */
angular.module('ffApp').directive('slideShow', function()
{
	return function(scope, element, attrs)
	{
		var firstRun = true;

		element.css('display', 'none');
		scope.$watch(attrs.slideShow, function(value)
		{
			if ( value )
			{
				if ( firstRun )
				{
					element.show();
				}
				else
				{
					element.slideDown(200);
				}
			}
			else
			{
				if ( firstRun )
				{
					element.hide();
				}
				else
				{
					element.slideUp(200);
				}
			}

			firstRun = false;
		});
	};
});

/**
 * Limit the number of rows in a comment text container
 */
angular.module('ffApp').directive('limitRows', function()
{
	return function(scope, element, attrs)
	{
		scope.$watch(element.html(), function(newValue, oldValue)
		{
			var rowsToShow = parseInt(attrs.limitRows) + 1;
			var lineHeight = parseInt(element.css('line-height').replace('px', ''));
			var heightLimit = rowsToShow * lineHeight;
			var margin = 8;
			var originalHeight = element.height();

			element.css('display', 'block');
			element.css('overflow', 'hidden');

			// If the text container's height is over the limit
			if ( originalHeight > heightLimit )
			{
				element.css('max-height', (heightLimit + margin) + 'px');

				var showMoreLink = $('<a class="read-more icon-dot-3" href=""></a>');

				showMoreLink.one('click', function(e)
				{
					e.stopPropagation();
					e.preventDefault();

					element.css('max-height', '');
					$(this).remove();

					return false;
				});

				element.append(showMoreLink);
			}
		});
	};
});